import { sign } from '../../../accounts/utils/sign.js';
import { keccak256 } from '../../../utils/hash/keccak256.js';
import { signatureToHex, } from '../../../utils/signature/signatureToHex.js';
import { toAuthMessage, } from './toAuthMessage.js';
/**
 * Computes a EIP-3074 authorization signature in format: `keccak256(MAGIC || chainId || nonce || invokerAddress || commit))`.
 */
export async function signAuthMessage(parameters) {
    const { privateKey } = parameters;
    const signature = await sign({
        hash: keccak256(toAuthMessage(parameters)),
        privateKey,
    });
    return signatureToHex(signature);
}
//# sourceMappingURL=signAuthMessage.js.map